exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-container[data-v-72233bcd]{background-color:#fff;border-radius:6px;padding:16px 0;margin-top:10px}.pagination-container .hidden[data-v-72233bcd]{display:none}", ""]);

// exports
